<template>
<div class="treeTableContainer">
  <div class="top">
    <el-checkbox v-model="allcheck" @change="allcheckedChange">全选</el-checkbox>
    <!-- <el-checkbox v-model="allTenantLogs" @change="allTenantLogsChange">全租户日志</el-checkbox> -->
  </div>
  <div class="treeTableTheader">
    <ul>
      <li v-for="(labelItem, index) in treeTableLabel" :key="index">
        {{ labelItem }}
      </li>
    </ul>
  </div>
  <div class="treeTableTbody">
    <!-- :default-checked-keys="checkedArray" 默认勾选的树节点 
        current-node-key 当前勾选的树节点
        setCheckedNodes设置目前勾选的节点，使用此方法必须设置 node-key 属性，(nodes) 接收勾选节点数据的数组
      :checkedArray="checkedArray"
      @check="handleCheckChange" -->
    <el-tree class="treeTableTree" ref="treeTableTree" check-on-click-node @check="handleCheckChange" :data="modulesData" :getCheckedNodes='sendTreeData' show-checkbox node-key="id" :indent="20" default-expand-all :expand-on-click-node="false">
      <!-- <span class="custom-tree-node" slot-scope="{ node, data }"> -->
      <span class="custom-tree-node" slot-scope="{ data }">
        <span class="itemLabel" :title="data.name">{{ data.name }}</span>
        <span class="itemUrl" :title="data.componentUrl">{{ data.componentUrl }}</span>
      </span>
    </el-tree>
  </div>
</div>
</template>

<script>
export default {
  props: ["modulesData", "treeTableLabel", "modulescheckedArray", "isEdit", "sendTreeData"],
  data() {
    return {
      checkArr: [],
      checkedArray: [],
      allcheck: false,
      allTenantLogs: false,
      allLogsModuleId: 0,
      modulesIdCount: 0,
      treeCount: '',
      bianPingArr:[]
    };
  },
  watch: {
    modulesData(newValue, oldValue) {
      console.log(newValue)
    }
  },

  mounted() {
    this.getTreeCount()
    this.resetTreeNode()

    this.$nextTick(() => {
      // this.init()
      this.resetTreeNode()
    //   this.sendTreeData.forEach((element) => {
    //     this.$refs.treeTableTree.setChecked(element, true);
    //   })
    });
  },
  methods: {
    init() {
      let nodes = this.$refs.treeTableTree.store.nodesMap;
      let moduleCount = 0;
      let checkArr = [];
      for (const key in nodes) {
        moduleCount++;
        checkArr.push(nodes[key].data.value);
      }
      this.modulesIdCount = moduleCount;
      this.checkArr = checkArr;

      if (this.isEdit) {
        let modulescheckedArray = this.modulescheckedArray;
        let length = modulescheckedArray.length;
        if (this.checkedArray.indexOf(61) != -1) {
          this.allTenantLogs = true;
          this.allcheck = length === this.modulesIdCount + 1;
        } else {
          this.allTenantLogs = false;
          this.allcheck = length === this.modulesIdCount;
        }
        this.checkedArray = [...modulescheckedArray];
      } else {
        let modulescheckedArray = [];
        for (const key in nodes) {
          modulescheckedArray.push(nodes[key].data.value);
        }
        this.checkedArray = [...modulescheckedArray];
      }
    },
    // 重置树节点
    resetTreeNode() {
      console.log(this.sendTreeData);
      console.log(this.sendTreeData.length);
      this.$refs.treeTableTree.setCheckedKeys(this.sendTreeData)
      this.getTreeCount()
    },
    // 关键获取所有的项目
    allCheckDiGui(dataList) {
      dataList.forEach(item => {
        if (item.children) {
          this.bianPingArr.push(item)
          this.allCheckDiGui(item.children)
        } else {
          this.bianPingArr.push(item)
        }
      })
      // console.log(this.bianPingArr);

      var newArr=[]
      for ( var j = 0; j < this.bianPingArr.length; j++ ) {
            if(newArr.indexOf(this.bianPingArr[j].id) === -1){
               newArr.push(this.bianPingArr[j].id)
            }    
        }
      // console.log(newArr);
      this.treeCount = newArr.length
      this.allcheck = this.$refs.treeTableTree.getCheckedKeys().length == this.treeCount
    },
    //获取树节点总数
    async getTreeCount() {
      // console.log(this.modulesData);
      this.allCheckDiGui(this.modulesData)
      // const {
      //   data: count,
      //   code
      // } = await this.request.get('/admin/module/count')
      // if (code !== 200) {
      //   // this.$message.error('获取树节点总数失败，请联系管理员')
      //   return
      // }
      // this.treeCount = count
      // this.allcheck = this.$refs.treeTableTree.getCheckedKeys().length == this.treeCount
    },
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data);
      // console.log(checked);
      // console.log(indeterminate);
      let half=checked.halfCheckedKeys
      // 选中传值---------------------
      // this.curCheckArr = checked.checkedKeys

      this.allcheck = checked.checkedKeys.length == this.treeCount
      // this.$emit("sendCheckNode", checked.checkedKeys.concat(half))
      this.$emit("sendCheckNode", checked.checkedKeys)
      this.$emit('halfCheckNode',half)
      // -----------------------------------
      // this.getNodesResult();
    },
    resetTree() {
      this.allcheck = false
    },
    allcheckedChange(checked) {
      this.allcheck = checked;
      // console.log(checked)
      // console.log(this.allcheck)
      // this.handleCheckChange()
      // console.log(this.$refs.treeTableTree.getCheckedKeys());
      // return
      this.$emit("chooseAll", this.allcheck);
      // let checkArr = [...this.checkArr];
      // console.log(checkArr)
      // ---------------------------全选传值
      this.$emit("sendCheckNode", this.allcheck ? this.$refs.treeTableTree.getCheckedKeys() : [])
      // ---------------------------全选传值
      // 全选---------------------------
      // console.log(checked)
      /*    if (checked) {
             checkArr.forEach((element) => {
                 this.$refs.treeTableTree.setChecked(element, true);
             });
         } else {
             checkArr.forEach((element) => {
                 this.$refs.treeTableTree.setChecked(element, false);
             });
         } */
      // 全选---------------------------
      // this.getNodesResult();
    },

    // ------------------------全租户日志
    allTenantLogsChange(val) {
      this.allTenantLogs = val;
      this.getNodesResult();
    },
    getNodesResult() {
      alert('该功能暂未实现')
    }
    /*     getNodesResult() {
          let checkArray = this.$refs.treeTableTree.getCheckedKeys();
          let checkArrayLength = checkArray.length;
          this.allcheck = checkArrayLength === this.modulesIdCount;
          // console.log(this.allcheck);
          if (this.allTenantLogs) {
            checkArray.push(61);
          }
          // console.log(checkArray);
          this.$emit("toParentChecked", checkArray);
        }, */
    // ------------------------全租户日志
  },
};
</script>

<style lang="scss">
.treeTableContainer {
  .top {
    height: 32px;
    line-height: 32px;

    .el-checkbox {
      line-height: 32px;
    }
  }

  .treeTableTheader {
    ul {
      height: 36px;
      background: rgba(155, 187, 250, 0.3);
      border-bottom: 2px solid #2662DC;

      li {
        float: left;
        width: 150px;
        line-height: 36px;
        padding: 0 10px;

        &:first-child {
          width: 266px;
          padding-left: 20px;
          padding-right: 0;
        }

        &:nth-child(2) {
          width: 150px;
        }

        &:nth-child(3) {
          width: 350px;
        }

        // &:nth-child(4){
        //   width:350px;
        // }
      }
    }
  }

  .treeTableTbody {
    .treeTableTree {
      .el-tree-node {
        white-space: normal;
      }

      .custom-tree-node {
        width: 1030px;

        span {
          display: inline-block;
          width: 150px;
          word-wrap: normal;
          word-break: break-all;
          padding: 0 10px;
        }

        .itemLabel {
          width: 180px;
          padding: 0;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }

        .itemUrl {
          width: 350px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }

        // .itemValue {
        //   width: 150px;
        // }
      }

      &>.el-tree-node {
        margin-bottom: 10px;

        &>.el-tree-node__content {
          height: auto;
          background: rgb(241, 242, 245);

          &>.custom-tree-node {
            span {
              padding: 8px 10px;
              line-height: 20px;
              vertical-align: middle;
            }

            .itemLabel {
              width: 220px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
        }

        &>.el-tree-node__children {
          padding-bottom: 1px;

          &>.el-tree-node {
            &>.el-tree-node__content {
              height: auto;

              &>.custom-tree-node {
                border-bottom: 1px solid #eee;

                span {
                  padding: 8px 10px;
                  line-height: 20px;
                  vertical-align: middle;
                }

                .itemLabel {
                  width: 200px;
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                }
              }
            }

            &>.el-tree-node__children {
              padding-bottom: 1px;

              &>.el-tree-node {
                &>.el-tree-node__content {
                  height: auto;

                  &>.custom-tree-node {
                    border-bottom: 1px solid #eee;

                    span {
                      padding: 8px 10px;
                      line-height: 20px;
                      vertical-align: middle;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
